import { Stack } from 'common/ui/Layout';
import { Colors } from 'styles';
import { PicklistOptionsViewer } from './PicklistOptionsViewer';
import { RightDrawerSection } from './RightDrawerSection';
import { Divider } from 'common/ui/Divider';
import Text from 'common/ui/Text';
import { css } from 'styled-components';

export const RightDrawerPicklistSection = (): React.ReactElement => {
  return (
    <>
      <Divider />
      <RightDrawerSection
        css={css`
          padding: 8px 24px;
        `}
      >
        <Stack vertical>
          <Text variant="body2" color={Colors.gray8}>
            Picklist
          </Text>
          <PicklistOptionsViewer />
        </Stack>
      </RightDrawerSection>
    </>
  );
};
